export default "__VITE_ASSET__DtYHmOVe__"